import {createReducer, on} from '@ngrx/store';
import * as OrganizationActions from '../actions/organization.actions';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const organizationFeatureKey = 'organization';

export interface State {
  record: Organization | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const reducer = createReducer(
  initialState,

  on(OrganizationActions.loadOrganization, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true
  })),
  on(OrganizationActions.loadOrganizationSuccess, (_state: State, action: {data: Organization}): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(OrganizationActions.loadOrganizationFailure, (_state: State, action: {error: any}): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(OrganizationActions.clearLoadOrganizationState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);
